var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-12 d-flex align-center justify-center",staticStyle:{"width":"100%","height":"80%"}},[_c('v-progress-circular',{attrs:{"width":5,"indeterminate":"","color":_vm.themeDark ? 'white' : 'primary',"size":"80"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }